import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import { useIsIntegrationClient } from '@frameio/shared/contexts/ClientNameContext';
import { useIsNLPEnabled } from '../../../../shared/hooks';

export const useIsQuickSearchFlyoutEnabled = () => {
  const isIntegrationClient = useIsIntegrationClient();
  return (
    useFeatureFlagEnabled('v4.quick_search_flyout') && !isIntegrationClient
  );
};

// use QuickSearch Flyout M2 Features (includes nlp functionality)
export const useIsQuickSearchFlyoutM2Enabled = () => {
  const isIntegrationClient = useIsIntegrationClient();
  const isNlpEnabled = useIsNLPEnabled();
  return (
    useFeatureFlagEnabled('v4.quick_search_flyout_m2') &&
    !isIntegrationClient &&
    isNlpEnabled
  );
};
